import React from 'react';
import colors from '../../colors';
import { Column, Name, Party, Bar, Progress, Value, Elected, withFace, grayscale } from './styles';
import { percentFormat } from '../../Utils/NumberFormatting'

const getRelative = (max, candidateResult) => max === 0 ? 0 : candidateResult / max * 100;

const coloured = elected => elected !== 'NEZVOLEN';

export default function BarComponent({ name, lastName, party, percent, max, roundIndex, elected, face, full, winAfterFirstRound }) {
	return <Column className={face ? withFace : null}>
		{face && <img src={face} width="100" height="100" className={coloured(elected[roundIndex]) ? null : grayscale} />}
		<Name>{name} {lastName}</Name>
		<Party title={party.name}>{party.shortcut}</Party>
		{full && !winAfterFirstRound && <Bar>
			<Progress style={{ height: getRelative(max, percent[roundIndex]) +'%', backgroundColor: colors[party.nid || party.id] || colors.default }} />
		</Bar>}
		{(full || roundIndex === 0) && <Value>{percentFormat(percent[roundIndex])}</Value>}
		{full && elected[roundIndex] === 'ZVOLEN' && <Elected>Zvolen</Elected>}
	</Column>;
}

BarComponent.defaultProps = {
	full: true
};
